<script lang="ts">
  import { CONTACT_COPY } from '@banger/shared';
  import { beginLogin, clearCustomClientId, customClientIdActive, logout } from '../spotify/auth';
  import { hostHref } from '../lib/tvWindow';
  import OwnSpotifyApp from './OwnSpotifyApp.svelte';

  let { reason, onapple }: {
    reason: 'not_allowed' | 'not_premium';
    /** Start a new game with Apple Music instead (from a click, so its sign-in popup can open). */
    onapple?: () => void;
  } = $props();
  let ownOpen = $state(false);
  const customActive = customClientIdActive();

  function switchBack() {
    clearCustomClientId();
    location.replace(hostHref());
  }

  function tryAnother() {
    logout();
    void beginLogin({ showDialog: true });
  }
</script>

<main>
  <h1 class="wordmark">BANGER!</h1>
  <p class="copy">{CONTACT_COPY}</p>
  {#if customActive}
    <p class="note custom">Using your own Spotify app? This Spotify account isn't allowed on it yet. Add it under User Management in your Spotify dashboard, or switch back to the default app.</p>
    <button class="own" onclick={switchBack}>Switch back to default</button>
  {/if}
  {#if reason === 'not_premium'}<p class="note">Hosting also needs a Spotify Premium account.</p>{/if}
  {#if onapple}<button class="btn-neon" onclick={onapple}>Use Apple Music instead</button>{/if}
  <button class="own" onclick={() => (ownOpen = true)}>🛠️ Use your own Spotify app (advanced)</button>
  <button class="own" onclick={tryAnother}>Try a different Spotify account</button>
  <p class="note"><a href="/?as=player">Join a game as a player instead</a></p>
</main>
{#if ownOpen}<OwnSpotifyApp onclose={() => (ownOpen = false)} />{/if}

<style>
  main { min-height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1.2rem; padding: 2rem; text-align: center; }
  h1 { margin: 0; font-size: clamp(3rem, 10vw, 7rem); line-height: 1; }
  .copy { margin: 0; max-width: 34ch; font-size: clamp(1.2rem, 2.6vw, 2rem); font-weight: 700; }
  .note { margin: 0; opacity: 0.75; font-size: clamp(1rem, 1.7vw, 1.3rem); }
  button { font-size: clamp(1.2rem, 2.4vw, 1.8rem); padding: 0.45em 1.6em; }
  .own {
    font-family: inherit; font-weight: 800; color: var(--cyan); cursor: pointer; border-radius: 999px;
    background: rgba(125, 249, 255, 0.08); border: 2px solid rgba(125, 249, 255, 0.6); box-shadow: 0 0 14px rgba(125, 249, 255, 0.3);
  }
  .custom { max-width: 46ch; }
  .own:hover, .own:focus-visible { box-shadow: 0 0 22px rgba(125, 249, 255, 0.6); }
</style>
